import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  ["Explore", [["All Brands", "/brands"], ["Categories", "/categories"], ["Recently Updated", "/recent"], ["Replay intro", "/?intro=replay"]]],
  ["PriceHub", [["About PriceHub", "/about"], ["Promote with PRICEHUB", "/promote"], ["Contact Us", "/legal/contact"], ["Admin Login", "/admin/login"]]],
  ["Legal", [["Privacy Policy", "/legal/privacy"], ["Terms and Conditions", "/legal/terms"], ["Disclaimer", "/legal/disclaimer"]]],
];

export function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#0B1020] text-slate-300" data-testid="site-footer">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#6366F1]/50 to-transparent" />
      <div className="absolute -right-40 -top-40 h-96 w-96 rounded-full bg-[#6366F1]/20 blur-[120px]" />
      <div className="relative mx-auto max-w-7xl px-5 pb-10 pt-20 md:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <Logo light />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300">
              PRICEHUB is a convenient digital destination for discovering and accessing electrical industry price lists from multiple brands in one place.
            </p>
          </div>
          {COLS.map(([title, links]) => (
            <div key={title}>
              <p className="font-mono-ph text-xs uppercase tracking-[0.2em] text-slate-400">{title}</p>
              <ul className="mt-5 space-y-3">
                {links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-slate-200 transition-colors hover:text-white hover:underline hover:decoration-[#B6FF5C] hover:underline-offset-4">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="mt-16 max-w-4xl text-xs leading-relaxed text-slate-400" data-testid="footer-disclaimer">
          PRICEHUB is an independent price-list directory. All brand names and trademarks belong to their respective owners. Price lists are provided for informational purposes. Always verify current pricing with the respective company or authorised distributor.
        </p>
        <div aria-hidden="true" className="ph-footer-word mt-10 select-none font-display font-extrabold leading-none tracking-[-0.06em]">PRICEHUB</div>
        <div className="mt-6 flex flex-col justify-between gap-2 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row">
          <span>© {new Date().getFullYear()} PRICEHUB. Every Brand. Every Price List.</span>
          <span>Independent directory · Not affiliated with listed brands</span>
        </div>
      </div>
    </footer>
  );
}
